import { render, staticRenderFns } from "./NewsletterModal.vue?vue&type=template&id=16663e08&scoped=true"
import script from "./NewsletterModal.vue?vue&type=script&lang=js"
export * from "./NewsletterModal.vue?vue&type=script&lang=js"
import style0 from "./NewsletterModal.vue?vue&type=style&index=0&id=16663e08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16663e08",
  null
  
)

export default component.exports